import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import type { IconProps } from '../../primitives/types.js';

/** Function glyph — italic lowercase f flanked by parentheses. Reads
 *  as `f( · )` so the icon means "function" without needing to draw
 *  the input variable explicitly. The italic f has the conventional
 *  ascending hook + descending tail; the parens are slim arcs sized
 *  to hug the f without crowding it at 14px. */
export function IcnFunction(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="function">
      {/* Italic f: hook at top, vertical body slanted, descender below baseline. */}
      <path d="M9.5 4 Q8.5 2.5 7 3 Q6 3.3 6 5 L5 12.5 Q4.7 14 3.5 14" />
      {/* Crossbar */}
      <path d="M4.5 8 H8.5" />
      {/* Left paren */}
      <path d="M3.5 4 Q2.5 8 3.5 12" />
      {/* Right paren */}
      <path d="M11 4 Q12 8 11 12" />
    </Svg>
  );
}
